import styled from 'styled-components';
import { Button, Input, Modal, Select, Slider } from 'antd';
import React, { useEffect } from 'react';
import { useExchangeSetting } from '@app/hooks/trade/exchangeSetting.tsx';
import BigNumber from 'bignumber.js';
import { useBinanceWebSocketStore } from '@app/hooks/binanceWebsocketStore.ts';
import { useMultiMarkPriceStore } from '@app/hooks/multiMarkPriceStore.tsx';
import { useIndexPrice } from '@app/hooks/trade/indexprice.tsx';
import { COLORS } from '@app/constants';
import { ThemeContext } from '@/theme/ThemeProvider.tsx';
import { useTranslation } from 'react-i18next';

export const MobileCloseByModal = ({open, setOpen, data, limitMarket, setLimitMarket, amount, setAmount, setSelectedPercent, selectedPercent, calculatedPnl, setCalculatedPnl, sendOrder, handleAmountChange  }) => {
  const { data:EpId,  } = useExchangeSetting(data?.exchange_pairs_id);
  const { getPrice } = useIndexPrice(data?.exchange_pairs_id);
  const indexPrice = getPrice(data?.exchange_pairs_id);
  const { textw } = React.useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();

  const [closePrice, setClosePrice] = React.useState<any>();


  const handlePriceChange = (e) => {
    // 입력값을 숫자로 변환하여 저장
    const value = e.target.value;
    setClosePrice(value === '' ? null : Number(value));

    // 지정가 주문일 때 가격 변경시 손익금액 계산
    if (value !== '' && limitMarket === 'L') {
      const usedPrice = Number(value);
      const usedAmount = amount || data?.amount;

      const pnlValue = BigNumber(data?.long_short === 'L' ? usedPrice : data?.price)
        .minus(data?.long_short === 'L' ? data?.price : usedPrice)
        .multipliedBy(usedAmount)
        .minus(data?.orders?.[0]?.fee_price || 0)
        .minus(BigNumber(data?.orders?.[0]?.fee_price || 0)
          .multipliedBy(data?.orders?.[0]?.amount ?
            BigNumber(data.amount).dividedBy(data.orders[0].amount).toNumber() : 1).toNumber())
        .toNumber();

      setCalculatedPnl(pnlValue);
    }
  };


  // useEffect(() => {
  //   console.log('datadata', data, symbol, markPriceData)
  //
  // }, [data])

  return (
    <Modal open={open} title={'Close By'} onCancel={() => setOpen(false)} centered={true} footer={null} width={'100%'}>
      <Contents>
        <InfoSection>
          <Label>
            {t("symbol")}
            <ValueText>
              {EpId?.pairs}
            </ValueText>
          </Label>

          <Label>
            {t("entryPrice")}
            <ValueText>
              {BigNumber(data?.price).toFormat(data?.dp || 3)}
            </ValueText>
          </Label>

          <Label>
            {t("marketAveragePrice")}
            <ValueText>
              {BigNumber(indexPrice).toFormat(data?.dp || 3)}
            </ValueText>
          </Label>
        </InfoSection>


        <ColumnLabel>
          {t("price")}
          <PriceSection>
            <StyleInput
              disabled={limitMarket === 'M'} style={{width: '50%'}}
              onChange={handlePriceChange}
              value={closePrice !== null && closePrice !== undefined
              ? Number(closePrice).toFixed(EpId?.dp || 3)
              : data?.price?.toFixed(EpId?.dp || 3)}/>
            <StyleSelect options={[{label: 'Market', value: 'M'}, {label: 'Limit', value: 'L'}]} style={{width: '50%'}} value={limitMarket} onChange={(e:any) => setLimitMarket(e)} />
          </PriceSection>
        </ColumnLabel>


        <ColumnLabel>
          {t("amount")}
          <StyleInput
            style={{width: '100%'}}
            value={amount}
            onChange={(e:any) => handleAmountChange(e)}
          />
          <StyledSlider marks={{
            0: '0%',
            25: '25%',
            50: '50%',
            75: '75%',
            100: '100%',
          }} min={0} max={100} value={selectedPercent * 100} onChange={(e:any) => setSelectedPercent(e/100)}/>
        </ColumnLabel>

        {/*<Label>*/}
        {/*  Position Amount*/}
        {/*  <ValueText>*/}

        {/*  </ValueText>*/}
        {/*</Label>*/}

        <Label>
          {t("estimatedLiqPrice")}
          <ValueText style={{ color: calculatedPnl > 0 ? COLORS.lightGreen : calculatedPnl < 0 ? COLORS.lightRed : textw }}>
            {calculatedPnl?.toFixed(4)} USDT
          </ValueText>
        </Label>

        <CheckButton type={'primary'} onClick={() => {
          sendOrder(limitMarket);
          setOpen(false);
        }}>
          {t("confirm")}
        </CheckButton>

      </Contents>
    </Modal>
  )
}


const CheckButton = styled(Button)`
    width: 100%;
    margin-top: 20px;
`



const Contents = styled.div`

`;

const Label = styled.div`
    display: flex;
  justify-content: space-between;
    margin-bottom: 10px;
`

const ColumnLabel = styled.div`
    margin-bottom: 10px;
`

const StyleInput = styled(Input)`
   
`

const StyleSelect = styled(Select)`
    width: 50%;
`

const ValueText = styled.div`

`

const InfoSection = styled.div`
    border-bottom: 1px solid ${COLORS.lightGray5};
    padding-bottom: 20px;
    margin-bottom: 20px;
`

const PriceSection = styled.div`
    display: flex;
    width: 100%;
  gap: 1%;
`

const StyledSlider = styled(Slider)`
    .ant-slider-rail {
        background-color: white; 
    }
`